import { subscriberIdApi } from '../../store';
import { formatSubscriberIdApiUrl } from '../../utils/formatApiUrl';
import { IInfoMeta, IInfoPiggyBank, IInfoTariff, IInfoTariffQuery } from './types';

export const infoApi = subscriberIdApi.injectEndpoints({
    endpoints: (builder) => ({
        getInfoGeneral: builder.query<IInfoMeta, string>({
            query: (subscriberId) => formatSubscriberIdApiUrl(subscriberId, 'info/general'),
        }),
        getTariff: builder.query<IInfoTariff, IInfoTariffQuery>({
            query: ({ subscriberId, regionId }) =>
                formatSubscriberIdApiUrl(subscriberId, `info/tariff?regionId=${regionId}`),
        }),
        /**
         * @deprecated use getTariff instead [BBPORTAL-14548]
         */
        getPiggyBank: builder.query<IInfoPiggyBank[], string>({
            query: (subscriberId) => formatSubscriberIdApiUrl(subscriberId, 'info/piggy-bank'),
            transformResponse: (response: { items: IInfoPiggyBank[] }) => response.items,
        }),
    }),
});

export const { useGetInfoGeneralQuery, useGetTariffQuery, useGetPiggyBankQuery } = infoApi;
